import React, { useContext, useState } from "react";
import FullButton from "../components/Buttons/FullButton";
import {
  Container,
  Form,
  FormWrapper,
  Input,
  Message,
  PageWrapper,
  StatusMessage,
  Wrapper,
} from "../style/view.styles";
import { loginUser } from "../utils/AuthHandler";
import { PasswordInput } from "../components/Inputs/PasswordInput";
import GoogleSSOButton from "../components/Buttons/GoogleSSOButton";
import { useNavigate } from "react-router-dom";
import { makeApiRequest } from "../utils/RequestHandler";
import { AuthContext } from "../contexts/AuthContext";

export default function Login() {
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });
  const { login } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAuth = async (
    authFn,
    successMessage = "Redirecting to dashboard..."
  ) => {
    setLoading(true);
    try {
      const result = await authFn();
      if (result) {
        login(result);
        setFormStatus({
          message: successMessage,
          type: "success",
        });
        navigate("/dashboard");
      } else {
        setFormStatus({
          message: "An unexpected error occurred. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      setFormStatus({
        message:
          error.message || "Something went wrong. Please contact support.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleAuthSuccess = async (response) => {
    const { credential } = response;

    await handleAuth(async () => {
      const response = await makeApiRequest("/google/sso/login/", "POST", {
        token: credential,
      });
      return response.success ? response.result : null;
    }, "Google authentication successful, redirecting...");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;

    await handleAuth(async () => {
      const result = await loginUser(email, password);
      return result;
    }, "User authentication successful, redirecting ...");
  };

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <PageWrapper className="container flexCenter">
            <FormWrapper>
              <h1 className="extraBold font40 darkGreenColor">Login</h1>
              <Form onSubmit={handleSubmit}>
                <Input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <PasswordInput
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
                <FullButton title={loading ? "Logging in..." : "Login"} />
                <GoogleSSOButton
                  onSuccess={handleGoogleAuthSuccess}
                  authType="login"
                />
              </Form>
              {formStatus.message && (
                <StatusMessage type={formStatus.type}>
                  {formStatus.message}
                </StatusMessage>
              )}
              <Message className="font13">
                Don't have an account? <a href="/register">Register here</a>
              </Message>
              <Message className="font13">
                Forgot password?{" "}
                <a href="/request-reset-password">Click here</a>
              </Message>
            </FormWrapper>
          </PageWrapper>
        </Container>
      </Wrapper>
    </>
  );
}
